import ContentsTypes from "@shared/enums/contentsTypes";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import ProjectArticleTemplate from "./ProjectArticleTemplate";
export default {
    key: "ARTICLE_DETAIL",
    label: "Article",
    description: "Contenu long",
    templateImage: "/template-article.png",
    useTags: true,
    Component: ProjectArticleTemplate,
    initialContents: [
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
        {
            key: "subpageSearch",
            type: customTypes.SUBPAGE_SEARCH,
            value: "",
            children: [
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "Articles recents",
                },
                {
                    key: "perPage",
                    type: ContentsTypes.INPUT_NUMBER,
                    value: "2",
                },
            ],
        },
        {
            key: "contactBlock",
            type: customTypes.CONTACT_BLOCK,
            value: "",
            children: [
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "Un projet a lancer, une equipe a mobiliser ?",
                },
                {
                    key: "subtitle",
                    type: ContentsTypes.INPUT,
                    value: "Beneficiez d'un accompagnement global porte par une equipe d'experts engages",
                },
                {
                    key: "link",
                    type: ContentsTypes.LINK,
                    value: "",
                    children: [
                        {
                            key: "url",
                            type: ContentsTypes.URL,
                            value: "/contact",
                        },
                        {
                            key: "title",
                            type: ContentsTypes.INPUT,
                            value: "Nous contacter",
                        },
                    ],
                },
            ],
        },
    ],
};
